import * as React from 'react'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'

import Review from './Review'
import SubmitButton from '../shared/SubmitButton'
import { IOrderLineItem } from 'src/models/IOrder'
import StripeCardSection from '../stripe-mui/StripeCardSection'

interface IPaymentProps {
  isSubmitting?: boolean
  isDisabled: boolean
  lineItems: IOrderLineItem[]
}

const Payment: React.SFC<IPaymentProps> = props => {
  const { lineItems, isDisabled, isSubmitting } = props

  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography variant="h6">Payment</Typography>
        <StripeCardSection />
      </Grid>
      <Grid item xs={12}>
        <Review lineItems={lineItems} processingFee={0.085} />
      </Grid>
      <Grid item xs={12} container justify="center">
        <SubmitButton isLoading={isSubmitting} isDisabled={isDisabled}>
          Submit Payment
        </SubmitButton>
      </Grid>
      <Grid item xs={12} container justify="center">
        <Typography variant="h6">
          All sales are final and non-refundable
        </Typography>
      </Grid>
    </Grid>
  )
}

export default Payment



// WEBPACK FOOTER //
// ./src/components/contest/Payment.tsx